import { css } from '@emotion/react'
import { mq } from 'plume-ui'

type Props = {
  src: string
  type?: 'full-column' | 'out-set'
}

export const MarkdownImage: React.FC<Props> = ({
  type = 'out-set',
  ...props
}) => {
  if (type === 'full-column') {
    return <FullColumnImage {...props} />
  }
  return (
    <img
      {...props}
      css={css`
        vertical-align: bottom;
      `}
    />
  )
}

type FullColumnImageProps = {
  src: string
}

const FullColumnImage: React.FC<FullColumnImageProps> = (props) => {
  return (
    <img
      css={css`
        padding: 0;
        vertical-align: bottom;
        ${mq.large} {
          border: none !important;
          padding-left: 48px;
          padding-right: 48px;
        }
      `}
      {...props}
    />
  )
}
